import React from 'react'

function StatusBadge({ status, type = 'default' }) {
  const getClass = () => {
    switch (type) {
      case 'success':
      case 'fulfilled':
      case 'paid':
      case 'ready':
        return 'badge-success'
      case 'warning':
      case 'pending':
      case 'partial':
      case 'flagged':
        return 'badge-warning'
      case 'error':
      case 'cancelled':
      case 'refunded':
      case 'unpriced':
        return 'badge-error'
      case 'info':
      case 'unfulfilled':
        return 'badge-info'
      case 'purple':
      case 'no-category':
        return 'badge-purple'
      default:
        return 'badge-neutral'
    }
  }

  return (
    <span className={`badge ${getClass()}`}>
      {status}
    </span>
  )
}

// Helper to get status badge for drafts
export function DraftStatusBadge({ draft }) {
  if (!draft.product_type) {
    return <StatusBadge status="No Category" type="purple" />
  }
  if (draft.isFlagged) {
    return <StatusBadge status="Needs Review" type="warning" />
  }
  if (draft.isUnpriced) {
    return <StatusBadge status="Unpriced" type="error" />
  }
  if (draft.sellPrice > 0) {
    return <StatusBadge status="Ready" type="success" />
  }
  return null
}

// Helper to get fulfillment status badge
export function FulfillmentBadge({ status }) {
  const displayStatus = status || 'unfulfilled'
  let type = 'info'
  if (displayStatus === 'fulfilled') type = 'success'
  else if (displayStatus === 'partial') type = 'warning'

  return <StatusBadge status={displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)} type={type} />
}

// Helper to get financial status badge
export function FinancialBadge({ status }) {
  let type = 'info'
  if (status === 'paid') type = 'success'
  else if (status === 'pending') type = 'warning'
  else if (status === 'refunded') type = 'default'

  return <StatusBadge status={status?.charAt(0).toUpperCase() + status?.slice(1) || 'Unknown'} type={type} />
}

export default StatusBadge
